import { Request,BaseApiUrl } from "./api";
// 工程模块
// 列表
export const getReportMainListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ReportMain/get`, { params: params });
};
//编辑
export const editReportMain = (params) => {
  return Request.post(`${BaseApiUrl}/api/ReportMain/put`, params);
};
//新增
export const addReportMain = (params) => {
  return Request.post(`${BaseApiUrl}/api/ReportMain/post`, params);
};
//批量删除
export const batchDeleteReportMain = (params) => {
  return Request.post(`${BaseApiUrl}/api/ReportMain/BatchDelete`, params);
};
// export const batchDeleteReportMain = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/ReportMain/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
export const getFile = (params) => {
  return Request({
    url: `${BaseApiUrl}/api/Upload/DownBmd`,
    method: "get",
    params: params,
    onDownloadProgress: (p) => {
      // this.precent = Math.floor(100 * (p.loaded / p.total))
    },
    responseType: "blob",
  });
};